import { useFormik } from "formik"
import authValidationSchema from "@auth/schemas/authValidationSchema"
import useToggle from "@shared/hooks/useToggle"
import type { LoginRequest } from "@auth/types/auth"
import useAuthentication from "@auth/hooks/useAuthentication"

const useLoginForm = () => {
    const [show, setShow] = useToggle()
    const { login } = useAuthentication();
    const {
        errors, 
        values, 
        touched, 
        handleSubmit, 
        handleReset,
        handleChange, 
        setFieldValue
    } = useFormik<LoginRequest>({
        initialValues: {
            UserCode: '',
            password: ''
        },
        onSubmit: async({ UserCode, password }) => {
           await login( UserCode, password)
        },
        enableReinitialize: false,
        validationSchema: authValidationSchema
    })

    return {
        show,
        errors, 
        values, 
        touched, 
        setShow,
        handleSubmit, 
        handleReset,
        handleChange, 
        setFieldValue
    }
}

export default useLoginForm